module.exports = __webpack_public_path__ + "static/media/add-user.deaea173.svg";